// Module
var code = `<div class="cage_hardware_widget">

    <!-- ko if: seed.inProgress() -->
        <div class="loading_circle"></div>
    <!-- /ko-->

    <!-- ko if: error() -->
        <div class="error tw:text-center tw:m-4" data-bind="text: error"></div>
    <!-- /ko -->

    <!-- ko if: !seed.inProgress() && seed() -->

        <div class="tecniplast" data-bind="with: tecniplast">

            <h3>Tecniplast DVC</h3>

            <div class="actions">

                <!-- ko if: !cage.known -->
                <button class="confirm" data-bind="disable: connectCageInProgress,
                                   text: translated('Connect'),
                                   attr: {title: translated('Create this cage in Tecniplast DVC.')},
                                   click: connectCageShow"></button>
                <!-- /ko-->

                <!-- ko if: cage.known && cage.position -->
                <button data-bind="disable: obtainTecniplastDVCPositionInProgress,
                                   text: translated('Obtain position'),
                                   attr: {title: translated('Obtain Tecniplast DVC Position to PyRAT.')},
                                   click: obtainTecniplastDVCPosition"></button>

                <!-- /ko-->

                <!-- ko if: cage.known -->
                <button data-bind="disable: updateTecniplastDVCCageInProgress,
                                   text: translated('Update DVC'),
                                   attr: {title: translated('Update this cage in Tecniplast DVC.')},
                                   click: updateTecniplastDVCCage"></button>
                <!-- /ko-->

                <!-- ko if: cage.known && cage.position -->
                <button data-bind="disable: turnLabelLEDOnInProgress,
                                   visible: !cage.led,
                                   text: translated('LED On'),
                                   attr: {title: translated('Turn the rack LED on.')},
                                   click: turnLabelLEDOn"></button>
                <!-- /ko-->

                <!-- ko if: cage.known && cage.position -->
                <button class="confirm" data-bind="disable: turnLabelLEDOffInProgress,
                                   visible: cage.led,
                                   text: translated('LED Off'),
                                   attr: {title: translated('Turn the rack LED off.')},
                                   click: turnLabelLEDOff"></button>
                <!-- /ko-->

                <!-- ko if: cage.known -->
                <button class="right warn" data-bind="disable: disconnectCageInProgress(),
                                   text: translated('Remove'),
                                   attr: {title: translated('Remove this cage from Tecniplast DVC.')},
                                   click: disconnectCage"></button>
                <!-- /ko-->

            </div>


            <div class="position">

                <label data-bind="text: translated('Position:')"></label>

                <!-- ko if: cage.position -->
                <span class="breadcrumbs">
                    <!-- ko if: cage.position.rackName-->
                        <span data-bind="text: cage.position.rackName"></span> &rarr;
                    <!-- /ko-->
                    <!-- ko if: cage.position.position -->
                        <span data-bind="text: cage.position.position"></span>
                    <!-- /ko-->
                </span>
                <!-- /ko-->

                <!-- ko if: !cage.position -->
                <span data-bind="text: translated('Unknown')"></span>
                <!-- /ko-->

            </div>
        </div>


        <div class="galilei" data-bind="with: galilei">

            <h3>Galilei CageTalker</h3>

            <div class="actions">
                <!-- ko if: cage.enrolled -->

                    <button data-bind="disable: updateLabelInProgress,
                                       text: translated('Update label'),
                                       attr: {title: translated('Update the cage label.')},
                                       click: updateLabel"></button>

                    <button data-bind="disable: turnLabelLEDOnInProgress,
                                       visible: !cage.flash_led_is_on,
                                       text: translated('LED On'),
                                       attr: {title: translated('Turn the label LED on.')},
                                       click: turnLabelLEDOn"></button>

                    <button class="confirm" data-bind="disable: turnLabelLEDOffInProgress,
                                       visible: cage.flash_led_is_on,
                                       text: translated('LED Off'),
                                       attr: {title: translated('Turn the label LED off.')},
                                       click: turnLabelLEDOff"></button>

                    <button class="warn right" data-bind="disable: unpairLabelInProgress,
                                       text: translated('Unpair'),
                                       attr: {title: translated('Unpair this label.')},
                                       click: unpairLabel"></button>

                <!-- /ko -->
            </div>

            <div class="meta">

                <!-- ko ifnot: cage.enrolled -->

                <form>
                    <label data-bind="text: translated('Label ID' + ':')"></label>
                    <input data-bind="textInput: freeLabelId, disable: pairLabelInProgress" maxlength="17">
                    <input type="submit" data-bind="click: pairLabel,
                                      enable: freeLabelId().length === 17 && !pairLabelInProgress(),
                                      attr: {value: translated('Pair')}">
                </form>

                <!-- /ko -->

                <!-- ko if: cage.enrolled -->

                <div>
                    <label data-bind="text: translated('Label ID' + ':')"></label>
                    <span data-bind="text: cage.label_id"></span>
                </div>

                <div>
                    <label data-bind="text: translated('Subcell' + ':')"></label>
                    <span data-bind="text: cage.sub_cell"></span>
                </div>

                <div>
                    <label data-bind="text: translated('Last update') + ':'"></label>
                    <span data-bind="text: cage.update_date_string"></span>
                </div>

                <div>
                    <label data-bind="text: translated('Status') + ':'"></label>
                    <span data-bind="text: cage.status"></span>
                </div>

                <!-- /ko -->

            </div>

            <div class="images" data-bind="with: cage.last_image">
                <img alt="label page 1" class="tw:inline" data-bind="visible: page_1,
                                attr: {src: 'data:image/png;base64,' + page_1}">
                <img alt="label page 2" class="tw:inline" data-bind="visible: page_3,
                                attr: {src: 'data:image/png;base64,' + page_2}">
                <img alt="label page 3" class="tw:inline" data-bind="visible: page_3,
                                attr: {src: 'data:image/png;base64,' + page_3}">
            </div>

        </div>


        <div class="reload_widget">
            <button class="right" data-bind="attr: {title: seed.lastSuccess() || ''},
                               text: translated('Reload'),
                               click: seed.forceReload"></button>
        </div>

        <!-- ko if: !tecniplast() && !galilei() -->
            <div class="no_data_message" data-bind="text: translated('No provider configured or available.')"></div>
        <!-- /ko -->

    <!-- /ko-->




</div>
`;
// Exports
export default code;